<template>
  <ul class="page-subnav">
    <slot></slot>
  </ul>
</template>

<script>
export default {};
</script>

<style lang="scss">
.page-subnav {
  position: absolute;
  bottom: 0px;
  left: 90px;
  margin: 0;
  padding: 0;

  .page-subnav-item {
    &::before {
      content: "[ ";
      font-style: normal;
      font-weight: bold;
    }

    &::after {
      content: " ]";
      font-style: normal;
      font-weight: bold;
    }
  }
}
</style>
